import type { PdMeasurementResult, ShMeasurementResult } from '../types'

const roundToTwoDecimals = (value: number) =>
  Math.round((value + Math.sign(value) * Number.EPSILON) * 100) / 100

export const roundPdMeasurementResult = (
  result: PdMeasurementResult
): PdMeasurementResult => ({
  pd: roundToTwoDecimals(result.pd),
  leftPd: roundToTwoDecimals(result.leftPd),
  rightPd: roundToTwoDecimals(result.rightPd),
  nearPd: roundToTwoDecimals(result.nearPd),
  nearLeftPd: roundToTwoDecimals(result.nearLeftPd),
  nearRightPd: roundToTwoDecimals(result.nearRightPd),
})

export const roundShMeasurementResult = (
  result: ShMeasurementResult
): ShMeasurementResult => ({
  left: roundToTwoDecimals(result.left),
  right: roundToTwoDecimals(result.right),
})
